// utils.js
export function getFormattedDate() {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();

  return `${day}/${month}/${year}`; //30/07/2025
}

export function getFormattedTime() {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0"); // 0-23
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`; //11:22:55
}

export function getFormattedDateJst() {
  const today = new Date();
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Asia/Tokyo",
  };
  const formatter = new Intl.DateTimeFormat("en-GB", options);

  return formatter.format(today); // 30/07/2025  This is japan time
}

export function getJSTDateStr(offsetDays = 0) {
  const now = new Date();
  const jstOffsetMs = 9 * 60 * 60 * 1000;
  const jstDate = new Date(now.getTime() + jstOffsetMs);

  // Apply offset (e.g., -1 for yesterday, +1 for tomorrow)
  jstDate.setDate(jstDate.getDate() + offsetDays);

  // Format as YYYY-MM-DD
  return jstDate.toISOString().split("T")[0];
}

export function getFormatDatesJst() {
  const today = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Asia/Tokyo",
  };

  const formatter = new Intl.DateTimeFormat("en-CA", options);
  const formatted = formatter.format(today);

  // return formatted.replace(/-/g, "-");   // 2025-08-23
  return formatted.replace(/-/g, "/"); // 2025/08/23
}

export function formatter(date) {
  return date.replace(/-/g, "/"); //2025-08-23 to  2025/08/23
}

export function zeroRemover(date) {
  return date?.replace(/:00$/, "");
}

export function extractDate(datetime) {
 const date =  datetime ? datetime.split(" ")[0] : "";
   return date.replace(/\//g, "-") ;
}

export function extractTime(datetime) {
 const time =  datetime ? datetime.split(" ")[1] : "";
   return zeroRemover(time) ;
}

export function getFormattedDatesJst() {
  const today = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Asia/Tokyo",
  };
  const formatter = new Intl.DateTimeFormat("en-CA", options);
  const formatted = formatter.format(today);

  return formatted.replace(/-/g, "-"); // 2025-08-23
  //  return formatted.replace(/-/g, "/");    // 2025/08/23
}

export function getFormattedYesterdayDateJst() {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const dateOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Asia/Tokyo",
  };
  const dateFormatter = new Intl.DateTimeFormat("en-CA", dateOptions);
  const formattedDate = dateFormatter.format(yesterday); // YYYY-MM-DD
  const timeOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit", // optional
    hour12: false,
    timeZone: "Asia/Tokyo",
  };
  const timeFormatter = new Intl.DateTimeFormat("en-GB", timeOptions);
  const formattedTime = timeFormatter.format(yesterday); // HH:mm:ss
  return `${formattedDate}T${formattedTime}`; //2025-08-04T13:19:08
}

export function getYesterdayMidnightDateTimeJst() {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  // Format date in JST as YYYYMMDD
  const dateOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Asia/Tokyo",
  };
  const dateFormatter = new Intl.DateTimeFormat("en-CA", dateOptions);
  const formattedDate = dateFormatter.format(yesterday).replace(/-/g, ""); // YYYYMMDD

  // Always return 0000 for midnight
  return `${formattedDate}T0000`; //20250812T0000
}

export function getFormattedTimeJst() {
  const now = new Date();

  // Convert to Japan time first
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Tokyo",
  };
  const formatter = new Intl.DateTimeFormat("en-GB", options);

  return formatter.format(now); // e.g., 18:45:30
}

export function formatCustomDate12(input) {
  if (!/^\d{8}T\d{4}$/.test(input)) return "Invalid format";

  const year = input.slice(0, 4);
  const month = input.slice(4, 6);
  const day = input.slice(6, 8);
  const hour = parseInt(input.slice(9, 11), 10);
  const minute = input.slice(11, 13);

  const datePart = `${year}-${month}-${day}`;

  const isPM = hour >= 12;
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  const timePart = `${String(hour12).padStart(2, "0")}:${minute} ${
    isPM ? "P.M" : "A.M"
  }`;

  return `${datePart} ${timePart}`; // convert 20250807T1800  to 2025-08-07 06:00 P.M
}

export function formatCustomDate(input) {
  if (!/^\d{8}T\d{4}$/.test(input)) return "Invalid format";

  const year = input.slice(0, 4);
  const month = input.slice(4, 6);
  const day = input.slice(6, 8);
  const hour = input.slice(9, 11);
  const minute = input.slice(11, 13);

  return `${year}-${month}-${day} ${hour}:${minute}`; // convert 20250807T1800  to 2025-08-07 18:00
}

export function compactDateTimeFormat12(input) {
  const match = input.match(
    /^(\d{4})-(\d{2})-(\d{2}) (\d{1,2}):(\d{2}) (A\.M|P\.M)$/i
  );

  if (!match) return "Invalid format";

  const [, year, month, day, hourStr, minute, meridiem] = match;

  let hour = parseInt(hourStr, 10);

  if (meridiem.toUpperCase() === "P.M" && hour !== 12) {
    hour += 12;
  } else if (meridiem.toUpperCase() === "A.M" && hour === 12) {
    hour = 0;
  }

  const hourStr24 = String(hour).padStart(2, "0");

  return `${year}${month}${day}T${hourStr24}${minute}`; // convert 2025-08-07 06:00 P.M to 20250807T1800
}

export function compactDateTimeFormat(input) {
  const match = input?.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/);

  if (!match) return "Invalid format";

  const [, year, month, day, hour, minute] = match;

  return `${year}${month}${day}T${hour}${minute}`; //for 24 hr format
}

export const addMinutes = (timeStr, minsToAdd) => {
  const [h, m] = timeStr.split(":").map(Number);
  let totalMinutes = h * 60 + m + minsToAdd;
  const newH = Math.floor(totalMinutes / 60);
  const newM = totalMinutes % 60;
  return `${String(newH).padStart(2, "0")}:${String(newM).padStart(2, "0")}`;
};